export const capsAlphaNumericOrHyphenOrUnderscore = value => (value ? (value.match(/(^[A-Z0-9_-]+)$/) ? undefined : 'Should contain only uppercase letters, digits, underscores, or hyphens') : undefined);
